import { render, staticRenderFns } from "./AppointmentScreenWrapper.vue?vue&type=template&id=0e82c9fe&"
import script from "./AppointmentScreenWrapper.vue?vue&type=script&lang=js&"
export * from "./AppointmentScreenWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e82c9fe')) {
      api.createRecord('0e82c9fe', component.options)
    } else {
      api.reload('0e82c9fe', component.options)
    }
    module.hot.accept("./AppointmentScreenWrapper.vue?vue&type=template&id=0e82c9fe&", function () {
      api.rerender('0e82c9fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/AppointmentPage/components/common/AppointmentScreenWrapper.vue"
export default component.exports